import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=0923557e&scoped=true"
import script from "./TrainingDetail.vue?vue&type=script&lang=js"
export * from "./TrainingDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainingDetail.vue?vue&type=style&index=0&id=0923557e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0923557e",
  null
  
)

export default component.exports